import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-701b99df"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "thought-admin-tools-section thought-admin-tools-section-broadcasts" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Broadcasts", -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Note that only one broadcast will show per page load. Eg if there is a broadcast for each FP and BS spaces then on the first load the user will see one, and then they can close it. Then when they load the next page (or refresh), the next one will show.", -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("A broadcast will only show for users who have been added to the space "),
  /*#__PURE__*/_createElementVNode("em", null, "after"),
  /*#__PURE__*/_createTextVNode(" the broadcast has been added. This is so when a broadcast is added it doesn't show to every user in that space.")
], -1 /* HOISTED */))
const _hoisted_5 = { class: "table table-bordered" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Location"),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createTextVNode("Video URL"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("(eg https://fast.wistia.net/embed/iframe/b9hxwa9pf)")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, "Copy"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1 /* HOISTED */))
const _hoisted_7 = { class: "broadcast-add" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "-1",
  disabled: ""
}, " Choose a space ", -1 /* HOISTED */))
const _hoisted_9 = ["value"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Location"),
    /*#__PURE__*/_createElementVNode("th", null, "Video URL"),
    /*#__PURE__*/_createElementVNode("th", null, "Copy"),
    /*#__PURE__*/_createElementVNode("th", null, "Remove")
  ])
], -1 /* HOISTED */))
const _hoisted_12 = { class: "broadcast-list" }
const _hoisted_13 = ["data-broadcast-id"]
const _hoisted_14 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createElementVNode("table", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("tbody", _hoisted_7, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newBroadcast.SpaceID) = $event))
            }, [
              _hoisted_8,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.spaces, (space) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: space.SpaceID,
                  value: space.SpaceID
                }, _toDisplayString(space.SpaceName), 9 /* TEXT, PROPS */, _hoisted_9))
              }), 128 /* KEYED_FRAGMENT */))
            ], 512 /* NEED_PATCH */), [
              [_vModelSelect, _ctx.newBroadcast.SpaceID]
            ])
          ]),
          _createElementVNode("td", null, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newBroadcast.VideoURL) = $event)),
              name: "videoUrl",
              type: "url",
              placeholder: "Video URL"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, _ctx.newBroadcast.VideoURL]
            ])
          ]),
          _createElementVNode("td", null, [
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newBroadcast.Copy) = $event)),
              name: "copy"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, _ctx.newBroadcast.Copy]
            ])
          ]),
          _createElementVNode("td", null, [
            _createElementVNode("button", {
              class: "btn",
              disabled: !_ctx.canAddBroadcast,
              onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.createBroadcast && _ctx.createBroadcast(...args)), ["prevent"]))
            }, " Add Broadcast ", 8 /* PROPS */, _hoisted_10)
          ])
        ])
      ]),
      _hoisted_11,
      _createElementVNode("tbody", _hoisted_12, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.broadcasts, (broadcast) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: broadcast.ID,
            "data-broadcast-id": broadcast.ID
          }, [
            _createElementVNode("td", null, _toDisplayString(broadcast.Space.SpaceName), 1 /* TEXT */),
            _createElementVNode("td", null, _toDisplayString(broadcast.VideoURL), 1 /* TEXT */),
            _createElementVNode("td", null, _toDisplayString(broadcast.Copy), 1 /* TEXT */),
            _createElementVNode("td", {
              class: "broadcast-delete-button",
              onClick: ($event: any) => (_ctx.deleteBroadcast(broadcast.ID))
            }, " X ", 8 /* PROPS */, _hoisted_14)
          ], 8 /* PROPS */, _hoisted_13))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ])
  ]))
}